import React from 'react';
import { CalendarDays, FileSearch, ShieldCheck } from 'lucide-react';
import { CALENDAR_LINK } from './Header';
const steps = [{
  title: '1. Agenda tu Consulta',
  description: 'Selecciona un horario en nuestro calendario para una llamada gratuita de 15-30 minutos. Sin compromisos.',
  icon: CalendarDays
}, {
  title: '2. Análisis Personalizado',
  description: 'Evaluamos tu situación financiera actual, tus metas de retiro y las necesidades de protección de tu familia.',
  icon: FileSearch
}, {
  title: '3. Implementa tu Plan',
  description: 'Diseñamos una póliza IUL a tu medida. Te guiamos paso a paso en la aplicación para asegurar tu futuro.',
  icon: ShieldCheck
}];
export function HowItWorks() {
  return <section id="como-funciona" className="py-20 bg-white" data-id="element-107">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-108">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-109">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-navy mb-4" data-id="element-110">
            Tu camino hacia la libertad financiera
          </h2>
          <p className="text-lg text-gray-600" data-id="element-111">
            Comenzar es más fácil de lo que piensas. Nuestro equipo de expertos
            te guiará en cada paso del proceso.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-112">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-gray-100 -translate-y-1/2 z-0" data-id="element-113"></div>

          {steps.map((step, index) => <div key={index} className="relative z-10 flex flex-col items-center text-center bg-white p-6" data-id="element-114">
              <div className="w-20 h-20 bg-brand-navy rounded-full flex items-center justify-center mb-6 shadow-lg border-4 border-white" data-id="element-115">
                <step.icon className="w-8 h-8 text-white" data-id="element-116" />
              </div>
              <h3 className="text-xl font-bold text-brand-navy mb-3" data-id="element-117">
                {step.title}
              </h3>
              <p className="text-gray-600" data-id="element-118">{step.description}</p>
            </div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-119">
          <a href={CALENDAR_LINK} target="_blank" rel="noopener noreferrer" className="inline-flex justify-center items-center bg-brand-green hover:bg-green-700 text-white px-8 py-4 rounded-md font-bold text-lg transition-all shadow-lg hover:shadow-xl" data-id="element-120">
            Comenzar el Paso 1 Ahora
          </a>
        </div>
      </div>
    </section>;
}